import API from "../../../../../services/api";

export const API_PIEZAS_RESERVADAS = {
  get: async () => {
    return await API.get("/piezas-reservadas").then((res) => res.data);
  },
  saveReserve: async (data) => {
    return await API.post(`/piezas-reservadas/`, data).then((res) => res.data);
  },
  quitReserve: async (idRef) => {
    return await API.put(`/piezas-reservadas/${idRef}`).then((res) => res.data);
  }
}